import { FormattedMessage } from 'react-intl';

import './style.css';

const Label = ({ labelId, labelDefaultMessage }) => {
  return (
    <div className="label-container">
      <label>
        <FormattedMessage
          id={labelId}
          defaultMessage={labelDefaultMessage || labelId}
        />
      </label>
    </div>
  );
};

export default Label;
